
const hasErrorAndTouched = (errors: any, touched: any, styles: any) => {

    if (!touched || !errors) return
    const fieldKeys = Object.keys(touched);

    const selectedField = fieldKeys.find((item) => {
        return item in errors
    })
    return selectedField !== undefined ? styles.error : ""
};

export default hasErrorAndTouched